import {browserTracingIntegration, createErrorHandler, init, instrumentOutgoingRequests, TraceService} from "@sentry/angular";



import { environment } from './environments/environment';
import { ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';

init({
  dsn: environment.sentryDsn,
  integrations: [
    browserTracingIntegration(),
    instrumentOutgoingRequests,
    // To re-enable session replay (~120 kB): add replayIntegration() here,
    // import it above, and uncomment replaysSessionSampleRate/replaysOnErrorSampleRate below.
  ],
  tracesSampleRate: environment.tracesSampleRate,
  // replaysSessionSampleRate: environment.replaysSessionSampleRate,
  // replaysOnErrorSampleRate: environment.replaysOnErrorSampleRate,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideNativeDateAdapter(),
    importProvidersFrom(
      AppRoutingModule,
      ),
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
      }),
    },
    provideAppInitializer(async () => inject(TraceService)),
  ]
})
  .then((success) => console.log('Bootstrap success'))
  .catch((err) => console.error(err));
